export var EditMode;
(function (EditMode) {
    EditMode["NEUTRAL"] = "NEUTRAL";
    EditMode["DRAGGING_STATE"] = "DRAGGING_PART";
    EditMode["ADD_STATE"] = "ADD_STATE";
    EditMode["ADD_TRANSITION"] = "ADD_TRANSITION";
    EditMode["DELETE"] = "DELETE";
    EditMode["EXECUTION"] = "EXECUTION";
    EditMode["EXECUTION_TRANSITION"] = "EXECUTION_TRANSITION";
})(EditMode || (EditMode = {}));
export const initialUiProgramStateMealy = {
    editMode: EditMode.NEUTRAL,
    type: 'UiProgramStateMealy',
    dragState: {
        stateId: '',
        dragOffset: { x: 0, y: 0 },
        dragged: false,
    },
    addTransition: {
        fromNodeId: null,
        mousePosition: { x: 0, y: 0 },
    },
    selection: {},
    pane: {
        scale: 100,
        translation: { x: 0, y: 0 },
    }
};
export const initialUiProgramStateDEA = {
    editMode: EditMode.NEUTRAL,
    type: 'UiProgramStateDEA',
    dragState: {
        stateId: '',
        dragOffset: { x: 0, y: 0 },
        dragged: false,
    },
    addTransition: {
        fromNodeId: null,
        mousePosition: { x: 0, y: 0 },
    },
    selection: {},
    pane: {
        scale: 100,
        translation: { x: 0, y: 0 },
    },
    execution: {
        inputPosition: 0,
    }
};
